import { template as template_6b29dccea6f54c7a851f89d665615cb7 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/html';
export default RouteTemplate(template_6b29dccea6f54c7a851f89d665615cb7(`
  <@model.Component @format={{@model.format}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
